import { ChangeDetectionStrategy, Component, inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ISyncOnboardingEditItem, ISyncOnboarding, IOnboardingEditItem } from '../fi-onboarding';
import { NgModel } from '@angular/forms';
import { AppTextService } from '@fi-app/shared/app-text';
import { FiContentLanguageSharedService } from '@fi-shared/fi-content-language-shared/fi-content-language-shared.service';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';
import { FiOnboardingService } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding.service';
import { isDefined } from '@fi-shared/utils';

@Component({
    selector: 'fi-onboarding-connect-edit',
    templateUrl: './fi-onboarding-connect-edit.component.html',
    styleUrl: './fi-onboarding-connect-edit.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-connect-edit' },
    standalone: false,
})
export class FiOnboardingConnectEditComponent implements OnInit {
    @Input({ required: true }) onboarding: ISyncOnboardingEditItem;
    @Input({ required: true }) syncReadyOnboardings: INameIdObj[] = [];

    protected masterOnboarding: IOnboardingEditItem;
    protected connectedOnboarding: IOnboardingEditItem;
    protected selectedOnboardings: IOnboardingEditItem[] = [];

    constructor(private fiOnboardingService: FiOnboardingService) {}

    ngOnInit() {}

    private readonly appTextService: AppTextService = inject(AppTextService);
    private readonly fiContentLanguageService: FiContentLanguageSharedService = inject(FiContentLanguageSharedService);

    protected selectedLanguageId = this.fiContentLanguageService.getDefaultContentLanguageId();

    protected getCurrentOnboardingName(): string {
        return (
            this.onboarding.Names.find((name) => name.ContentLanguageId === this.selectedLanguageId)?.Value ||
            this.appTextService.get('onboarding.name')
        );
    }

    protected onMasterOnboardingChanged(masterOnboarding: IOnboardingEditItem) {
        this.masterOnboarding = masterOnboarding;
        this.updateSelectedOnboardings();
    }

    protected onConnectedOnboardingChanged(connectedOnboarding: IOnboardingEditItem) {
        this.connectedOnboarding = connectedOnboarding;
        this.updateSelectedOnboardings();
    }

    private updateSelectedOnboardings() {
        this.selectedOnboardings = [];
        if (isDefined(this.masterOnboarding)) {
            this.selectedOnboardings.push(this.masterOnboarding);
        }
        if (isDefined(this.connectedOnboarding)) {
            this.selectedOnboardings.push(this.connectedOnboarding);
        }
    }

    protected handleCheckpointEditorFormError($event: NgModel[]) {}

    protected logger() {}

    protected save() {
        this.fiOnboardingService.saveOnboarding(this.onboarding);
    }
}
